import { Component, OnInit, Input, ChangeDetectorRef, ViewRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { restore } from "../../assets/json/restoreTooltip.en";
import { Options } from "@angular-slider/ngx-slider";

import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';

import { Subject } from "rxjs";
import { AloAocStateService } from "../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-rso",
  templateUrl: "./rso.component.html",
  styleUrls: ["./rso.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RsoComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  formatVersion: LegacyAny;
  column: LegacyAny;
  properties: LegacyAny = [];
  defaultColor: boolean = true;
  inputError: LegacyAny = [];
  CurveSelection: LegacyAny;
  CurveSelectionVal: LegacyAny;
  ngModelval: LegacyAny = {};
  restoreText = restore;
  userSpecified: boolean = false;
  curveSurveyValues = {};
  dimLevelColumn = [];
  outputVoltageColumn = [];
  quickConfigvalue;
  quickConfigCustomCSS;
  setQuickConfig;
  fileResponse: LegacyAny;
  isEdited: LegacyAny;
  rsoDefaultColor;
  rsoCreateFile: boolean;
  rsoForm: FormGroup;
  unsubscribe = new Subject<void>();
  constructor(
    
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private featureData: FeatureDataStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
    //super();
  }

  ngOnInit() {
    this.rsoForm = this.fb.group({
      rsoVal: new FormControl("", [Validators.required]),
    });
    this.isEdited = false;
    this.formatVersion = this.field.featureVersion;
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.featureDefaults.getrsoDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.rsoDefaultColor = true;
        this.resetDefaultrsoValues();
      }
    });
    this.featureData.getrsoData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.checkdfault();
        this.checkInvalidValues();
      }
    });
    this.ngModelval["Enabled"] = this.properties.Enabled.default;
    if (this.properties.Enabled.default === true) {
      this.rsoForm.controls["rsoVal"].setValue("1");
      this.ngModelval["Enabled"] = "1";
    } else {
      this.rsoForm.controls["rsoVal"].setValue("0");
      this.ngModelval["Enabled"] = "0";
    }
    const aaa = this.appState.getSaveSetData();
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "RSO") {
          isConfigEdited = true;
          this.fileResponse = {};
          const rsoUnSelectedVal: LegacyAny = element["featureParameters"][0];
          this.addrsoLoadedFeatureReadValues(rsoUnSelectedVal);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
        // Use centralized method to get feature data
        // This automatically prioritizes SaveSetData over ConfigurationData
        const rsoData = this.appState.getFeatureData('RSO');
        if (rsoData) {
          this.addrsoLoadedFeatureReadValues(rsoData);
        }
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    this.sendrsodata(this.ngModelval);
    this.isEdited = true;
  }

  resetDefaultrsoValues() {
    this.ngModelval["Enabled"] = this.properties.Enabled.default;
    if (this.properties.Enabled.default === true) {
      this.rsoForm.controls["rsoVal"].setValue("1");
      this.ngModelval["Enabled"] = "1";
    } else {
      this.rsoForm.controls["rsoVal"].setValue("0");
      this.ngModelval["Enabled"] = "0";
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.rsoCreateFile = false;
    this.featureData.rsoInputError(this.rsoCreateFile);
    this.sendrsodata(this.ngModelval);
  }
  sendrsodata(val) {
    this.featureData.sendrsodata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "RSO");
    }
  }
  setConfigurationData(value, keyVal) {
    if (value != null) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const rsoObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, rsoObj);
    }
  }
  checkdfault() {
    this.rsoDefaultColor = true;
    this.properties = this.field.properties;
    if (this.ngModelval["Enabled"] === "1") {
      this.ngModelval["Enabled"] = "1";
    } else {
      this.ngModelval["Enabled"] = "0";
    }
    for (const type in this.ngModelval) {
      if (this.ngModelval[type] != this.properties[type]["default"]) {
        this.rsoDefaultColor = false;
      }
    }
    this.featureData.rsoEditedVal(this.rsoDefaultColor);
  }
  checkInvalidValues() {
    this.rsoCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.rsoCreateFile = true;
      }
    }
    this.featureData.rsoInputError(this.rsoCreateFile);
  }

  addrsoLoadedFeatureReadValues(rso: LegacyAny) {
    const rsoObj = rso;
    const keys = Object.keys(rsoObj);
    const values = Object.values(rsoObj);
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    this.ngModelval["Enabled"] = result["Enabled"];
    if (this.ngModelval["Enabled"] === "1" || this.ngModelval["Enabled"] === true) {
      this.rsoForm.controls["rsoVal"].setValue("1");
      this.ngModelval["Enabled"] = "1";
    } else {
      this.rsoForm.controls["rsoVal"].setValue("0");
      this.ngModelval["Enabled"] = "0";
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.sendrsodata(this.ngModelval);
  }
  handleChange(eventVal) {
    this.ngModelval["Enabled"] = eventVal.target.value;
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.rsoCreateFile = false;
    this.featureData.rsoInputError(this.rsoCreateFile);
    this.sendrsodata(this.ngModelval);
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
  }
}

